import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { LessonModel } from '@generativ/much-smarter-models';

import { LessonService } from '../../exercise/shared/lesson.service';
import { ProblemMultipleChoiceContainerComponent } from '../../exercise/shared/problem-mo-container/problem-multiple-choice-container.component';
import { SpinnerComponent } from '../../../../shared/spinner/spinner.component';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-lesson-strategy-answer',
    templateUrl: './lesson-strategy-answer.component.html',
    styleUrls: ['./lesson-strategy-answer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProblemMultipleChoiceContainerComponent, SpinnerComponent, AsyncPipe]
})
export class LessonStrategyAnswerComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  lesson: Observable<LessonModel>;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private lessonService: LessonService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['lessonId']) {
        this.lesson = this.lessonService.getLesson(params['lessonId']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleNext() {
    const currentExerciseId = localStorage.getItem('currentExerciseId');
    this.router.navigate([`../exercises/${currentExerciseId}/get-started`], {relativeTo: this.activatedRoute});
  }
}
